module.exports = __webpack_public_path__ + "img/starter-fm-bangaz.9698becf.png";